import {Environment} from "./config";

export const environment: Environment = {
  name: "stage",
  production: false,
  baseURL: {
    mag2www: "https://www.stg.mag2.com/",
    mag2mypage: "https://mypage.stg.mag2.com/",
    magliveWeb: "https://live.stg.mag2.com/",
    magliveAPI: "https://live.stg.mag2.com/",
    magticketWeb: "https://ticket.stg.mag2.com/",
    magticketAPI: "https://ticket.stg.mag2.com/",
    magliveIcon: "https://live.stg.mag2.com/",
    edgeAPI: "https://edge-api.castify.jp/",
    edgeCDN: "https://edge-cdn.castify.jp/",
    castify: undefined,
    mag2WSDomain: "wss://ws.stg.saga.mag2.com/ws",
  },
  firebase: {
    apiKey: "AIzaSyCvLGgyZM5YzNdocmoCrJii7uGwlZs_j6s",
    authDomain: "stg-live-mag2-com.firebaseapp.com",
    databaseURL: "https://stg-live-mag2-com.firebaseio.com",
    projectId: "stg-live-mag2-com",
    storageBucket: "stg-live-mag2-com.appspot.com",
    messagingSenderId: "1088815180305",
    appId: "1:1088815180305:web:cc7aee79875850aa"
  },
  debugUsers: [
    {name: "未ログイン", userId: null},
    {name: "管理者 (全権限)", userId: 1},
    {name: "管理者 (LIVE運用担当者)", userId: 2},
    {name: "管理者 (経理担当者)", userId: 3},
    {name: "発行者(1)", userId: 5023365},
    {name: "発行者(2)", userId: 5023382},
    {name: "発行者(3)", userId: 5023403},
    {name: "発行者(4)", userId: 5023404},
    {name: "発行者(5)", userId: 5023405},
    {name: "発行者(6)", userId: 5023406},
    {name: "発行者(7)", userId: 5023762},
    {name: "発行者(8)", userId: 5023842},
    {name: "読者(1)", userId: 5023364},
    {name: "読者(2)", userId: 5023366},
    {name: "読者(3)", userId: 5023383},
    {name: "読者(4)", userId: 5023407},
    {name: "読者(5)", userId: 5023423},
    {name: "読者(6)", userId: 5023763},
    {name: "読者(7)", userId: 5023922},
    {name: "読者(8)", userId: 5023923},
  ],
};
